import React from "react";

const ResultLoadingModal = ({}) => {
    return (
        <div
            className="fixed inset-0 z-[999999999999999999999] flex items-center justify-center bg-black/95">
            <div className="flex flex-col items-center font-satoshi bg-[#313232] rounded-xl w-[80%] md:w-[50%] min-w-[250px] max-w-[400px] mx-auto p-6">
                <div className="w-full text-white rounded-lg overflow-hidden text-center">
                    <div className="w-full text-center">
                        <div className="mb-4 text-xl font-semibold">
                            Session over
                        </div>
                        <span className="loader"></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultLoadingModal;
